
import { OnInit, Component,ViewEncapsulation, Input,Output,EventEmitter,SimpleChanges  } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { APIResponse, MFAPrefrences, MFAQRCodePayload, MFAUserPreferences } from '@shared/models/auth.interface';
import { LoadingService } from '@shared/services/core/loading.service';
import { MfaDataService } from '@shared/services/mfa-data.service';
import { AuthMFAService } from '@shared/services/auth/auth-mfa.service';
import { SnackbarService } from '@shared/services/core/snackbar.service';
import { LogService } from '@shared/services/core/log.service';
import { appQRdata, CheckPreference, Country, MFAAuthType, MFAPrefResponse, Question, SavePreferencesPayload, SMS, verifyOTPPayload } from '@shared/models/mfa-prefrences.interface';
import { finalize, take,Subscription,of,catchError } from 'rxjs';
import { SessionService } from '@shared/services/auth/session.service';
import { ExtendedLogDetails } from '@shared/models/log.interface';
import { UserprofileMfaService } from '@shared/services/auth/userprofile-mfa.service';
import { UserInfoService } from '@shared/services/auth/user-info.service';
import { ValidatorsHelper } from '@shared/helpers/validators.helper';
import { MatCheckboxChange } from '@angular/material/checkbox';


@Component({
    selector: 'app-set-preferences',
    templateUrl: './set-preferences.component.html',
    styleUrls: ['./set-preferences.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class SetPreferences implements OnInit {

    @Input() userMfaPreferences!: MFAPrefResponse;
    public countries: Country[] = [];
    public mfaAuthTypes: MFAAuthType[] = [];
    public questions: Question[] = [];
    public sms: SMS[] = [];
    public downloadAppStep: FormGroup;
    public otpValues: string[] = new Array(6).fill('');
    public otpArray = Array(6);
    invalidOtp: boolean = false;
    selectedAuthTypeId!: number;
    authTypeMsgMap: { [key: number]: string } = {
        1: 'page.MFASettings.matStepLabel.step3.AuthenticationMethod.DefaultSMSMsg',
        2: 'page.MFASettings.matStepLabel.step3.AuthenticationMethod.DefaultEmailMsg',
        3: 'page.MFASettings.matStepLabel.step3.AuthenticationMethod.DefaultSecurityQuesMsg',
        4: 'page.MFASettings.matStepLabel.step3.AuthenticationMethod.DefaultQRappMsg'
    };
    selectedTabIndex = 0;
    @Input() appQRdata!: appQRdata;
    public mfaData: { mfaPref: MFAPrefrences; clientMfa: MFAUserPreferences } | null = null;
    securityQuestionForm: FormGroup;
    authMethodForm: FormGroup;
    contactDetailsForm: FormGroup;
    tabVisited = false;
    tabCompleted = false;
    // isSecurityTabDisabled = true;
    // isAppTabDisabled = true;
    // isContactTabDisabled = true;
    payload!: SavePreferencesPayload;
    mfaDataSub!: Subscription;
    defaultCountry: Country | undefined;
    originalSecurityFormValue: any;
    originalContactFormValue: any;
    CheckPreference!: CheckPreference;
    public isNextButtonClicked:boolean = false;
    @Output() preferencesSaved = new EventEmitter<void>();
    private IslastChangeSource: boolean = false;
    IsClient = this._userInfoService.isUserTypeClient();
    ClientData = this._userInfoService.getClientInfo();
    ProfData = this._userInfoService.getProfessionalInfo();
    public DefaultMFAValidTillDays = 0;
    public userMFAValidTillDays = 0; // Default value for MFA Valid Till Days
    isNextButtonClickedTemp: boolean=false;
    infoUrl = 'https://knowledge.entireonhire.com/en/x.1-release-notes-august-2025';

    constructor(private formBuilder: FormBuilder,
        private loadingService: LoadingService,
        private mfaDataService: MfaDataService,
        private authService: AuthMFAService,
        private snackbarService: SnackbarService,
        private logService: LogService,
        private sessionService: SessionService,
        private router: Router,
        private userprofileMfaService: UserprofileMfaService,
    private _userInfoService: UserInfoService) {

        this.downloadAppStep = this.formBuilder.group({
            accountInputCtrl: ['',],
            keyInputCtrl: ['',]
        });

        this.securityQuestionForm = this.formBuilder.group({
            question1: [null, Validators.required],
            answer1: ['', [Validators.required, Validators.maxLength(100)]],
            question2: [null, Validators.required],
            answer2: ['', [Validators.required, Validators.maxLength(100)]],
            AnswerId1:[],
            AnswerId2:[]
        });

        this.authMethodForm = this.formBuilder.group({
            authType: [0, Validators.required],
            ValidTillDays: [0, [ ValidatorsHelper.numeric, Validators.max(365)]]
        });

        this.contactDetailsForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email,Validators.maxLength(50)]],
            countryId: [null, Validators.required],
            phone: ['', [Validators.required,Validators.maxLength(15), Validators.pattern(/^(?!0)(?!0+$)[0-9]{1,15}$/)]]

        });

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['userMfaPreferences'] && changes['userMfaPreferences'].currentValue) {
          console.log('userMfaPreferences changed:', changes['userMfaPreferences'].currentValue);
          const {
            Countries = [],
            MFAAuthTypes = [],
            Questions = [],
            SMS,
            QuestionsMaster = []
          } = changes['userMfaPreferences'].currentValue || {};
  
          this.userMfaPreferences = changes['userMfaPreferences'].currentValue;
          this.countries = Countries;
          this.mfaAuthTypes = MFAAuthTypes;
          this.questions = QuestionsMaster;
          this.sms = SMS ? [SMS] : [];
          // Patch security questions form with safe defaults
          this.securityQuestionForm.patchValue({
            AnswerId1: Questions[0]?.AnswerId ?? 0,
            question1: Questions[0]?.Id ?? null,
            answer1: Questions[0]?.Id ? '***************' : '',
            answer2: Questions[0]?.Id ? '***************' : '',
            question2: Questions[1]?.Id ?? null,
            AnswerId2: Questions[1]?.AnswerId ?? 0,
          });
  
          // Set default country
          const defaultCountryId = Countries.find((c: { IsDefault: any; }) => c.IsDefault)?.Id ?? null;
          this.contactDetailsForm.get('countryId')?.setValue(defaultCountryId);
  
          // Set phone and authType if SMS exists
          if (SMS) {
            this.contactDetailsForm.get('email')?.setValue(SMS.UserEmailId??'');
            this.contactDetailsForm.get('phone')?.setValue(SMS.PhoneNumber ?? '');
           // this.authMethodForm.get('authType')?.setValue(SMS.AuthTypeId ?? null);
           // this.authMethodForm.get('ValidTillDays')?.setValue(SMS.MFAValidTillDays ?? 0);
          }
        }
    }
    ngOnInit(): void {
        console.log("userMfaPreferences",this.userMfaPreferences);
       this.mfaDataSub= this.mfaDataService.mfaData$.subscribe((data: { mfaPref: MFAPrefrences; clientMfa: MFAUserPreferences; } | null) => {
            if (!data) {
              // If application realod i.e Data missing in service, redirect to login
               this.router.navigate(['/login']);
            }else{
                this.mfaData = data;
                this.contactDetailsForm.patchValue({
                    'email': data.clientMfa.UserEmailId || '',
                    //'countryId': data.clientMfa. || null,
                    'phone': data.clientMfa.UserPhoneNumber || ''
                });
                this.authMethodForm.get('authType')?.setValue(data.clientMfa.DefaultAuthId || 0);
                this.selectedAuthTypeId= data.clientMfa.DefaultAuthId || 0;
            }
        });

        if (this.userMfaPreferences) {
            this.countries = this.userMfaPreferences.Countries || [];
            this.defaultCountry = this.countries.find(c => c.IsDefault);
            // Set the form control value if a default country exists
            if (this.defaultCountry) {
              this.contactDetailsForm.get('countryId')?.setValue(this.defaultCountry.Id);
            }
            this.mfaAuthTypes = this.userMfaPreferences.MFAAuthTypes || [];
            this.questions = this.userMfaPreferences.QuestionsMaster || [];
            this.sms = this.userMfaPreferences.SMS ? [this.userMfaPreferences.SMS] : [];
            this.CheckPreference=this.userMfaPreferences.CheckPreference || {};
            this.originalContactFormValue=this.contactDetailsForm.getRawValue();
        }

        // if (!this.mfaDataService.hasQrCode) {
        //     const payload:MFAQRCodePayload={
        //         'clientId': this.mfaData?.clientMfa.userId || '',
        //         'Action':'Reset', // Reset action to fetch new QR code
        //         'AccessCode': this.mfaData?.clientMfa.CompanyCode || ''
        //     }
        //     this.mfaDataService.fetchQrCodeIfNeeded(payload).subscribe((response:any) => {
        //         if (response && response.QrCodeUrl) {
        //             if (this.mfaData?.mfaPref) {
        //               this.mfaData.mfaPref.IsAuthenticatorAppConfigured = true;
        //             }
        //             this.appQRdata = response;
        //             this.downloadAppStep.patchValue({
        //               'accountInputCtrl': response.Account,
        //               'keyInputCtrl': response.ManualEntryKey
        //             });
                  
        //           }
        //     })
        // }else{
        //         this.mfaDataService.qrCode$.subscribe((data: appQRdata | null) => {
        //             if (data) {
        //                 this.appQRdata = data;
        //                 this.downloadAppStep.patchValue({
        //                     'accountInputCtrl': data.Account,
        //                     'keyInputCtrl': data.ManualEntryKey
        //                 });
        //             }
        //         });
        //     }
       
    }


    // Date: 2023-10-05
    // Purpose: Handle backspace in OTP fields and move focus to the previous field if the current field is empty.
    public onBackspace(event: any, index: number): void {
        const currentInputValue = this.otpValues[index];
        if (!currentInputValue && index > 0) {
            const prevInput = event.target.previousElementSibling;
            if (prevInput) {
                prevInput.focus();
            }
        } else {
            this.otpValues[index] = '';
        }
    }

    // Date: 2023-10-05
    // Purpose: Validate if all OTP fields are filled with single digits.
    public isOtpValid(): boolean {
        return this.otpValues.every(value => value.trim().length === 1);
    }

    clearOtp() {
        this.otpValues = Array(this.otpArray.length).fill('');
    }

    // Date: 2023-10-05
    // Purpose: Handle input in OTP fields and move focus to the next field when a digit is entered.  
    public onInput(event: any, index: number): void {
        const inputValue = event.target.value;
        if (inputValue.length === 1 && index < this.otpArray.length - 1) {
            const nextInput = event.target.nextElementSibling;
            if (nextInput) {
                nextInput.focus();
            }
        }
    }
    private setValidators(controls: any, validators: any) {
        Object.entries(validators).forEach(([key, validator]) => {
            controls[key]?.setValidators(validator);
            //controls[key]?.markAsTouched();
            controls[key]?.updateValueAndValidity();
        });
    }

    private clearAllValidators() {
        [this.securityQuestionForm, this.contactDetailsForm, this.downloadAppStep].forEach(form => {
            if (form) {
                Object.values(form.controls).forEach((control: any) => {
                    control.clearValidators();
                    control.updateValueAndValidity();
                });
            }
        });
    }

    onAuthTypeChange(selectedId: number) {
        // this.tabVisited = false;
        // this.tabCompleted = false;
        this.selectedAuthTypeId = selectedId;
        const selectedType = this.mfaAuthTypes.find(type => type.Id === selectedId);
        const name = selectedType?.Name?.toLowerCase() || '';
         if (!name.includes('app')) {
         this.mfaDataService.qrCodeSubject.next(null); // Clear QR code if switching to non-App tab
         this.checkForQrCode('Delete'); // Delete QR code if switching to App other tab
         } 
    

        // this.clearAllValidators();
        // const validatorMap: { [key: string]: () => void } = {
        //     security: () => this.setValidators(this.securityQuestionForm.controls, {
        //         question1: [Validators.required],
        //         answer1: [Validators.required,Validators.maxLength(100)],
        //         question2: [Validators.required],
        //         answer2: [Validators.required,Validators.maxLength(100)]
        //     }),
        //     sms: () => this.setValidators(this.contactDetailsForm.controls, {
        //         phone: [Validators.required,Validators.maxLength(15), Validators.pattern(/^(?!0)(?!0+$)[0-9]{1,15}$/)],
        //         countryId: [Validators.required]
        //     }),
        //     email: () => this.setValidators(this.contactDetailsForm.controls, {
        //         email: [Validators.required, Validators.email,Validators.maxLength(50)]
        //     }),
        //     app: () => Object.values(this.downloadAppStep.controls).forEach((control: any) => {
        //         control.updateValueAndValidity();
        //     })
        // };

        // Object.keys(validatorMap).forEach(key => {
        //     if (name.includes(key)) {
        //         validatorMap[key]();
        //     }
        // });
    }



    goToStepForAuthType(authTypeId: number) {
        this.tabVisited = true;
         this.isNextButtonClicked = true;
         this.IslastChangeSource = true; // Set this to true to indicate that the Next button was clicked
        const selectedType = this.mfaAuthTypes.find(type => type.Id === authTypeId);
        if (!selectedType) {
            this.selectedTabIndex = 0;
            return;
        }
        const name = selectedType.Name.toLowerCase();

        // // Enable only the relevant tab
        // this.isSecurityTabDisabled = !name.includes('security');
        // this.isAppTabDisabled = !name.includes('app');
        // this.isContactTabDisabled = !(name.includes('sms') || name.includes('email'));

        if (name.includes('security')) {
            this.selectedTabIndex = 1; // Security Question tab index
        } else if (name.includes('app')) {
            this.selectedTabIndex = 2; // Mobile App Authentication tab index
            this.checkForQrCode('Reset');  
        } else if (name.includes('sms') || name.includes('email')) {
            this.selectedTabIndex = 3; // Contact Details tab index
        } else {
            this.selectedTabIndex = 0; // Default to first tab if not matched
        }
    }

    checkForQrCode(Action:string) {
        // const payload: MFAQRCodePayload = {
        //           clientId: this.mfaData?.clientMfa.userId || '',
        //           Action: Action, // Reset action to fetch new QR code, Delete on tab saved other than App
        //           AccessCode: this.mfaData?.clientMfa.CompanyCode || ''
        //         };
        //      this.authService.getMfaQrCode(payload).pipe(
        //     finalize(() => {
        //         this.loadingService.stopLoading();
        //     }),
        //     catchError((error: ExtendedLogDetails | undefined) => {
        //       this.logService.error('Error fetching QR code', error);
        //       this.snackbarService.showErrorSnackBar(
        //         'Error',
        //         'Failed to fetch QR code. Please try again later.',
        //         'none'
        //       );
        //       return of(null); 
        //     })
        //   ).subscribe((response: appQRdata | null) => {
        //     if (response) {
        //       this.appQRdata = response;
        //       this.downloadAppStep.patchValue({
        //         'accountInputCtrl': this.appQRdata.Account,
        //         'keyInputCtrl': this.appQRdata.ManualEntryKey
        //       });
        //     }
        //   });
     const handleQrCode = (response: appQRdata | null) => {
    if (response && response.QrCodeUrl) {
      if (this.mfaData?.mfaPref) {
        this.mfaData.clientMfa.IsAuthenticatorAppConfigured = true;
      }
      this.appQRdata = response;
      this.downloadAppStep.patchValue({
        'accountInputCtrl': response.Account,
        'keyInputCtrl': response.ManualEntryKey
      });
    }
  };

  if (!this.mfaDataService.hasQrCode) {
    const payload: MFAQRCodePayload = {
      clientId: this.mfaData?.clientMfa.userId || '',
      Action: Action, // Reset action to fetch new QR code, Delete on tab saved other than App
      AccessCode: this.mfaData?.clientMfa.CompanyCode || ''
    };
    this.mfaDataService.fetchQrCodeIfNeeded(payload).pipe(take(1)).subscribe(handleQrCode);
  } else {
    this.mfaDataService.qrCode$.pipe(take(1)).subscribe(handleQrCode);
  }
    }

    onTabFormSaved(saveAuthVal?:boolean) {
        this.IslastChangeSource = (this.isNextButtonClickedTemp || saveAuthVal) ?? false;
        this.tabCompleted = true;
        //this.selectedTabIndex = 0;
        // Update original values after save
        this.originalSecurityFormValue = this.securityQuestionForm.getRawValue();
        this.originalContactFormValue = this.contactDetailsForm.getRawValue();
        let payload: any = {
             UserId: this.mfaData?.clientMfa?.userId ?? '',
            IsPreferencesSet: this.mfaData?.mfaPref?.isPreferenceSet ?? 0,
            AuthTypeId: this.IslastChangeSource ? (this.authMethodForm.get('authType')?.value):0,
            MFAValidTillDay:Number(this.authMethodForm.get('ValidTillDays')?.getRawValue()) || 0
         };
        switch (this.selectedTabIndex) {
            case 1:// Security Questions Tab
            const answer1 = this.securityQuestionForm.get('answer1')?.value;
            const answer2 = this.securityQuestionForm.get('answer2')?.value;

                payload = {
                    ...payload,
                    AnswerId1:this.securityQuestionForm.get('AnswerId1')?.value ?? 0,
                    AnswerId2:this.securityQuestionForm.get('AnswerId2')?.value ?? 0,
                    Ques1Id: this.securityQuestionForm.get('question1')?.value ?? 0,
                    //AnswerDesc1: this.securityQuestionForm.get('answer1')?.value,
                    Ques2Id: this.securityQuestionForm.get('question2')?.value ?? 0,
                    ...(answer1 && !answer1.includes('*') ? { AnswerDesc1: answer1 } : {}),
                    ...(answer2 && !answer2.includes('*') ? { AnswerDesc2: answer2 } : {})
                  
                    //AnswerDesc2: this.securityQuestionForm.get('answer2')?.value
                  };
                  this.checkForQrCode('Delete');
                break;
            case 3: // Contact Details Tab
            payload = {
                ...payload,
                CountryId: this.contactDetailsForm.get('countryId')?.value,
                PhoneNumber: this.contactDetailsForm.get('phone')?.value,
                EmailId: this.contactDetailsForm.get('email')?.value
              };
              this.checkForQrCode('Delete');    
                break;
            case 2:
                payload = {
                    ...payload
                }
                break;
            case 0:
                payload = {
                    ...payload
                }
                break;
            default:
                break;
        }
        this.payload = payload;
        this.procedTosavePref();
        // this.payload = {
        //     UserId: this.mfaData?.clientMfa?.userId ?? '',
        //     AuthTypeId: this.authMethodForm.get('authType')?.value,
        //     Ques1Id: this.securityQuestionForm.get('question1')?.value??0,
        //     AnswerDesc1: this.securityQuestionForm.get('answer1')?.value,
        //     Ques2Id: this.securityQuestionForm.get('question2')?.value??0,
        //     AnswerDesc2: this.securityQuestionForm.get('answer2')?.value,
        //     CountryId: this.contactDetailsForm.get('countryId')?.value,
        //     PhoneNumber: this.mfaData?.clientMfa?.UserPhoneNumber ?? this.contactDetailsForm.get('phone')?.value,
        //     EmailId: this.mfaData?.clientMfa?.UserEmailId ?? this.contactDetailsForm.get('email')?.value,
        //     IsPreferencesSet: this.mfaData?.mfaPref?.isPreferenceSet ?? 0
        //   };

    }

    procedTosavePref() {
        this.loadingService.showLoading();
        const jti = this.mfaDataService.jti;
        if (jti) {
            const tokenKey = this.sessionService.getToken(jti);
            this.authService.SaveMFAPrefrences(this.payload, jti, tokenKey)
                .pipe(finalize(() => this.loadingService.stopLoading()))
                .subscribe({
                    next: (response: any) => {
                        const isSuccess = response?.Data === true;
                        const message = isSuccess ? 'Preferences saved successfully.' : 'Failed to save preferences.';
                        if (isSuccess) {
                            this.snackbarService.showSuccessSnackBar('Success', message, '');
                            if(this.IslastChangeSource){
                                const landingPageRoute= this.mfaDataService.landingPageRoute;
                                this.router.navigateByUrl(landingPageRoute as string);
                            }
                            this.preferencesSaved.emit();
                        } else {
                            this.snackbarService.showErrorSnackBar('Error', message, '');
                        }
                    },
                    error: (err: any) => {
                        console.error('API error:', err);
                        this.snackbarService.showErrorSnackBar('Error', 'Failed to save preferences. Please try again.', '');
                    }
                });
        } else {
            this.loadingService.stopLoading();
            console.error('Error', 'JTI not found.');
        }

        this.isNextButtonClicked = false; 
    }

    onChangeTab(event:any) {
        this.selectedTabIndex=event?.index || 0;
        //  this.isSecurityTabDisabled = true;
        //  this.isAppTabDisabled=true;
        // this.isContactTabDisabled=true;
        //this.IslastChangeSource = this.isNextButtonClicked;
         // If the tab change is not triggered by the Next button, reset the flag
            if (!this.isNextButtonClicked) {
                this.IslastChangeSource = false;
            }

        if(event?.index==0){
            this.securityQuestionForm.reset(this.originalSecurityFormValue);
            this.contactDetailsForm.reset(this.originalContactFormValue);
        }
    
        if( this.isNextButtonClicked)
        {
            this.isNextButtonClickedTemp = true;

        }
        this.isNextButtonClicked = false; // Always reset after any tab change
       if(event.index===2){
        this.checkForQrCode('Reset')
       }
    }

    get question1() { return this.securityQuestionForm.get('question1')?.value; }
    get question2() { return this.securityQuestionForm.get('question2')?.value; }
    get isProceedEnabled(): boolean {
        return !!this.authMethodForm.get('authType')?.value;
    }

    get showSaveButton(): boolean {
        return (
          (this.selectedAuthTypeId === 1 && this.CheckPreference?.IsPhoneNumberSet) ||
          (this.selectedAuthTypeId === 2 && this.CheckPreference?.IsEmailSet) ||
          (this.selectedAuthTypeId === 3 && this.CheckPreference?.IsQuestionsSet)||
          (this.selectedAuthTypeId === 4 && this.CheckPreference?.IsAuthenticatorAppConfigured)
        );
      }
      
      get showNextButton(): boolean {
        return (
            (this.selectedAuthTypeId === 1 && !this.CheckPreference?.IsPhoneNumberSet) ||
            (this.selectedAuthTypeId === 2 && !this.CheckPreference?.IsEmailSet) ||
            (this.selectedAuthTypeId === 3 && !this.CheckPreference?.IsQuestionsSet)||
            (this.selectedAuthTypeId === 4 && !this.CheckPreference?.IsAuthenticatorAppConfigured)
        
        );
      }


      onQuestionChange(questionNumber: number) {
        const answerControl = `answer${questionNumber}`;
        this.securityQuestionForm.get(answerControl)?.reset();
      }

       verifyOtp() {
        const otp = this.otpValues.join('');
            this.loadingService.showLoading();
            const { authType } = this.authMethodForm.value;
            const payload:verifyOTPPayload={
                'UserId': this.mfaData?.clientMfa?.userId ?? '',
                'Otp': otp,
                'AuthTypeId': authType
            }
            const jti = this.mfaDataService.jti;
            const tokenKey = this.sessionService.getToken(jti);
            this.authService.VerifyAppOTP(payload,jti,tokenKey).pipe(
                finalize(() => {
                    this.loadingService.stopLoading();
                }),
                catchError((error: ExtendedLogDetails | undefined) => {
                  this.snackbarService.showErrorSnackBar(
                    'Error',
                    'Failed to Verify Code. Please try again later.',
                    'none'
                  );
                  return of(null); 
                })
              ).subscribe((response:  APIResponse<boolean> | null) => {
                if (response?.HttpStatusCode===200) {
                  this.invalidOtp=false;
                  
                  this.clearOtp(); // Clear the OTP fields after successful verification
                  this.onTabFormSaved(true);
                  this.snackbarService.showSuccessSnackBar('Success', 'Data updated successfully.', 'none');
                }else{
                  this.invalidOtp=true;
                }
              });
            
          }

    getDefaultMFAValidTillDays(event: MatCheckboxChange): void {
        const config = this.userMfaPreferences?.Configuration;
        const isChecked = event.checked;
        const defaultDays = config?.DefaultMFAValidTillDays ?? this.DefaultMFAValidTillDays;
        const normalDays = config?.MFAValidTillDays ?? this.userMFAValidTillDays;
        const valueToSet = isChecked ? defaultDays : normalDays;
        this.authMethodForm.get('ValidTillDays')?.setValue(valueToSet);
        if (isChecked) {
            this.authMethodForm.get('ValidTillDays')?.disable();
          } else {
            this.authMethodForm.get('ValidTillDays')?.enable();
          }
    }

    handlePaste(event: ClipboardEvent) {
        event.preventDefault();
        const pastedData = event.clipboardData?.getData('text')?.trim();
      
        if (!pastedData) return;
      
        // Keep only digits
        const digits = pastedData.replace(/\D/g, '');
      
        if (!digits) return;
      
        // Split and fill the OTP array
        for (let i = 0; i < this.otpArray.length; i++) {
          this.otpValues[i] = digits[i] ?? '';
        }
      
    
      
        // Enable verification button if full OTP entered
       // this.isVerifyButtonEnabled = this.otpValues.every(v => v !== '');
      
        // Move focus to last input
        setTimeout(() => {
          const inputs: NodeListOf<HTMLInputElement> =
            document.querySelectorAll('.otp-input');
          inputs[this.otpArray.length - 1]?.focus();
        });
          }

    ngOnDestroy(): void {
         this.mfaDataSub?.unsubscribe();
         this.mfaDataService.qrCodeSubject.next(null); // Clear QR code on destroy
       }
}